import React from 'react';
import PropTypes from 'prop-types';
import DialogWithContent from '../../../../components/common/DialogWithContent/DialogWithContent';
import { Grid, IconButton, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

function AddOrEditBasicEventInfo(props) {
    const {
        openEditDialog,
        setOpenEditDialog,
        formConfig,
        form,
        renderField,
        updateExistingEvent,
    } = props;
    return (
        <DialogWithContent
            open={openEditDialog}
            dialogTitle={`Edit Event Info`}
            setOpen={setOpenEditDialog}
            dialogMaxWidth="lg"
            // //defaultValue={transcriptionTextToEdit}
            handleSave={updateExistingEvent}
        >
            <Grid container item spacing={1} sx={{ alignItems: 'flex-start' }}>
                <Grid item xs={12} sx={{ mt: 4 }}>
                    <Typography color="primary" variant="h6">
                        Customer Details
                    </Typography>
                </Grid>
                {formConfig?.fields?.map((field) => {
                    if (
                        field.enable_field &&
                        (field.field_name === 'customerName' ||
                            field.field_name === 'phone' ||
                            field.field_name === 'email')
                    ) {
                        return (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={4}
                                key={field.field_name}
                                sx={{ display: 'flex' }}
                            >
                                {renderField(field)}
                                {field.field_name === 'phone' &&
                                form[field.field_name]?.length !== 0 ? (
                                    <IconButton
                                        color="primary"
                                        href={`tel:${form[field.field_name]}`}
                                        sx={{ padding: 0.5 }}
                                    >
                                        <PhoneIcon
                                            sx={{
                                                fontSize: 30,
                                            }}
                                        />
                                    </IconButton>
                                ) : field.field_name === 'email' &&
                                  form[field.field_name]?.length !== 0 ? (
                                    <IconButton
                                        color="primary"
                                        href={`mailto:${
                                            form[field.field_name]
                                        }`}
                                        sx={{ padding: 0.5 }}
                                    >
                                        <EmailIcon
                                            sx={{
                                                fontSize: 30,
                                            }}
                                        />
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                            </Grid>
                        );
                    }
                })}
            </Grid>

            <Grid item container spacing={2} sx={{ alignItems: 'flex-start' }}>
                <Grid item xs={12} sx={{ mt: 4 }}>
                    <Typography color="primary" variant="h6">
                        Event Details
                    </Typography>
                </Grid>
                {formConfig?.fields?.map((field) => {
                    if (
                        field.enable_field &&
                        field.field_name !== 'customerName' &&
                        field.field_name !== 'phone' &&
                        field.field_name !== 'email'
                    ) {
                        return (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={4}
                                key={field.field_name}
                                sx={{ display: 'flex' }}
                            >
                                {renderField(field)}
                            </Grid>
                        );
                    }
                })}
            </Grid>
        </DialogWithContent>
    );
}

AddOrEditBasicEventInfo.propTypes = {
    openEditDialog: PropTypes.bool.isRequired,
    setOpenEditDialog: PropTypes.func.isRequired,
    formConfig: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    renderField: PropTypes.func.isRequired,
    updateExistingEvent: PropTypes.func.isRequired,
};

export default AddOrEditBasicEventInfo;
